var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutoStories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2685_9774",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2685_9774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 33.3334C19.1666 32.2778 17.7222 31.4584 16.1666 30.875C14.6111 30.2917 13 30 11.3333 30C10.1666 30 9.02079 30.1528 7.89579 30.4584C6.77079 30.7639 5.6944 31.1945 4.66663 31.75C4.08329 32.0556 3.52079 32.0417 2.97913 31.7084C2.43746 31.375 2.16663 30.8889 2.16663 30.25V10.1667C2.16663 9.86115 2.24301 9.56949 2.39579 9.29171C2.54857 9.01393 2.77774 8.8056 3.08329 8.66671C4.36107 8.00004 5.6944 7.50004 7.08329 7.16671C8.47218 6.83337 9.88885 6.66671 11.3333 6.66671C12.9444 6.66671 14.5208 6.87504 16.0625 7.29171C17.6041 7.70837 19.0833 8.33337 20.5 9.16671V29.3334C21.9166 28.4445 23.4027 27.7778 24.9583 27.3334C26.5138 26.8889 28.0833 26.6667 29.6666 26.6667C30.6666 26.6667 31.6458 26.75 32.6041 26.9167C33.5625 27.0834 34.5277 27.3334 35.5 27.6667V7.66671C35.9166 7.8056 36.3264 7.95143 36.7291 8.10421C37.1319 8.25699 37.5277 8.44449 37.9166 8.66671C38.2222 8.8056 38.4514 9.01393 38.6041 9.29171C38.7569 9.56949 38.8333 9.86115 38.8333 10.1667V30.25C38.8333 30.8889 38.5625 31.375 38.0208 31.7084C37.4791 32.0417 36.9166 32.0556 36.3333 31.75C35.3055 31.1945 34.2291 30.7639 33.1041 30.4584C31.9791 30.1528 30.8333 30 29.6666 30C28 30 26.3888 30.2917 24.8333 30.875C23.2777 31.4584 21.8333 32.2778 20.5 33.3334ZM23.8333 25V9.16671L32.1666 0.833374V17.5L23.8333 25Z",
    fill: "#EE2524"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoStories);
export default __webpack_public_path__ + "static/media/auto_stories.4977bd0b.svg";
export { ForwardRef as ReactComponent };